import { render, staticRenderFns } from "./buyShopSms.vue?vue&type=template&id=4d8e4c55&scoped=true"
import script from "./buyShopSms.vue?vue&type=script&lang=js"
export * from "./buyShopSms.vue?vue&type=script&lang=js"
import style0 from "./buyShopSms.vue?vue&type=style&index=0&id=4d8e4c55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8e4c55",
  null
  
)

export default component.exports